// extracted by mini-css-extract-plugin
export default {"link":"index-module__link--MpLeO","board":"index-module__board--e5WbD","special":"index-module__special--3MXNQ","hash":"index-module__hash--wn9tp"};